/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsShift } from "../../entities/models/Shift";
import { z } from "zod/v4";

export const modelsShiftSchema = z.object({
    "barber_id": z.optional(z.int()),
"created_at": z.optional(z.string()),
"current_status": z.optional(z.string()),
"end_time": z.optional(z.string()),
"id": z.optional(z.int()),
"pause_ends_at": z.optional(z.string()),
"pause_started_at": z.optional(z.string()),
"start_time": z.optional(z.string()),
"station_id": z.optional(z.int()),
"status": z.optional(z.string())
    }) as unknown as z.ZodType<ModelsShift>